import { Pagination as MuiPagination } from '@mui/material';
import {
  useGridApiContext,
  useGridSelector,
  gridPageCountSelector,
  GridPagination,
} from '@mui/x-data-grid-pro';

function Actions({ page, onPageChange, className }) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
}

export function Pagination(props) {
  return <GridPagination ActionsComponent={Actions} {...props} />;
}
